import * as React from 'react'
import {maybe} from '@freckle/maybe'
import {SyncUpdatesButton} from '@frontrow/console/src/components/common/school-actions-section/sync-updates-button'
import {SyncIdpButton} from './sync-idp-button'

export type StatusT = 'initial' | 'awaiting_response' | 'failed' | 'success'

type Props = {
  clientId?: string
  schoolId: number
  active: boolean
}

export default function SchoolActionsSection({
  clientId,
  schoolId,
  active
}: Props): React.ReactElement {
  const syncUpdatesButton = maybe(
    () => null,
    cId => (active ? <SyncUpdatesButton clientId={cId} /> : null),
    clientId
  )
  return (
    <div className="mt-2 flex flex-wrap items-start gap-4">
      {syncUpdatesButton}
      <SyncIdpButton schoolId={schoolId} />
    </div>
  )
}
